import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { NavigationBasePage } from '@shared/pages';
import { Constants } from '@shared/models';

@Component({
    'selector': 'app-navigation5Congratulations',
    'templateUrl': './navigation5Congratulations.page.html',
    'styleUrls': ['./navigation5Congratulations.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class Navigation5CongratulationsPage extends NavigationBasePage implements OnInit, OnDestroy {
    constructor(injector: Injector) {
        super(injector);
        super.setCurrentView(Constants.VIEW_NAVIGATION_PAGE5);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        // this.eventsService.publish(Constants.EVENT_NAV_MORE_MENU_CHANGE);

        // Allow the application pages to fall asleep again. 
        // this.keepAwake();
        this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-navigation-5-tour');
    }

    public onRoutesClick(): void {
        this.router.navigateByUrl('/routes');
    }
}
